import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isOpenConnectDBModal: false,
  dbTypes: [
    // { value: "mysql", displayValue: "MySQL" },
    // { value: "mongodb", displayValue: "MongoDB" },
  ],
  databaseList: [],
  selectDB: "",
  selectTable: "",
  selectDatabase: "",
  selectBackup: "",
};

const WarehouseReducer = createSlice({
  name: "WarehouseReducer",
  initialState: initialState,
  reducers: {
    openConnectDBModal: (state) => {
      return {
        ...state,
        isOpenConnectDBModal: true,
      };
    },
    setDBTypeValue: (state, { payload }) => {
      const dbTypeExists = state.dbTypes.some(
        (dbType) => dbType.value === payload.value
      );
      return {
        ...state,
        dbTypes: dbTypeExists ? state.dbTypes : [...state.dbTypes, payload],
      };
    },
    setSelectDB: (state, { payload }) => {
      return {
        ...state,
        selectDB: payload,
      };
    },
    setSelectDatabase: (state, { payload }) => {
      return {
        ...state,
        selectDatabase: payload,
      };
    },
    setSelectTable: (state, { payload }) => {
      return {
        ...state,
        selectTable: payload,
      };
    },
    setSelectBackupFile: (state, { payload }) => {
      return {
        ...state,
        selectBackup: payload,
      };
    },
    setDatabaseList: (state, { payload }) => {
      return {
        ...state,
        databaseList: payload,
      };
    },
    clearDatabaseList: (state) => {
      return {
        ...state,
        databaseList: [],
      };
    },
    clearSelectTable: (state) => {
      return {
        ...state,
        selectTable: "",
      };
    },
    clearSelectDB: (state) => {
      return {
        ...state,
        selectDB: "",
        selectDatabase: "",
      };
    },
    clearSelectBackup: (state) => {
      return {
        ...state,
        selectBackup: "",
      };
    },
    closeConnectDBModal: (state) => {
      return {
        ...state,
        isOpenConnectDBModal: false,
      };
    },
  },
});
export default WarehouseReducer;
